import '../../client/index.js';
import { wrapErrorManager } from '../../utils/error-manager.js';
import { transformSalesCheckoutBillingAddressRequest, transformSalesCheckoutCouponResponse, transformSalesCheckoutGiftOptionsResponse, transformSalesCheckoutMeTotalsResponse, transformSalesCheckoutPaymentMethodsResponse, transformSalesCheckoutShippingMethodsResponse, transformPostSalesCheckoutShippingMethodsResponse, transformSalesGiftWrapResponse, transformSalesCheckoutShippingRequest, transformSalesCheckoutShippingResponse, transformSalesCheckoutPlaceOrderRequest, transformSalesCheckoutPlaceOrderResponse, transformSalesPaymentCheckoutDetailsResponse, transformSalesPaymentInitResponse, transformSalesCheckoutVatValidationRequest, transformSalesCheckoutVatValidationResponse } from './transformers.js';
import defaultClient from 'axios';

const postSalesCheckoutBillingAddress = async ({ client , controller , billingAddress , email  })=>await client.post(`V1/sales/checkout/billing-address`, {
        billingAddress,
        email
    }, {
        signal: controller?.signal,
        transformRequest: [
            transformSalesCheckoutBillingAddressRequest,
            ...(client || defaultClient).defaults.transformRequest
        ]
    });
postSalesCheckoutBillingAddress.key = 'postSalesCheckoutBillingAddress';
const postSalesCheckoutCoupon = async ({ client , controller , code  } = {})=>await client.post(`V1/sales/checkout/coupon`, {
        coupon_code: code
    }, {
        signal: controller?.signal
    });
postSalesCheckoutCoupon.key = 'postSalesCheckoutCoupon';
const getSalesCheckoutCoupon = async ({ client , controller  } = {})=>await client.get(`V1/sales/checkout/coupon`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesCheckoutCouponResponse)
        ]
    });
getSalesCheckoutCoupon.key = 'getSalesCheckoutCoupon';
const deleteSalesCheckoutCoupon = async ({ client , controller  } = {})=>await client.delete(`V1/sales/checkout/coupon`, {
        signal: controller?.signal
    });
deleteSalesCheckoutCoupon.key = 'deleteSalesCheckoutCoupon';
const postSalesCheckoutGiftCards = async ({ client , controller , code  } = {})=>client.post(`V1/sales/checkout/gift-cards`, {
        gift_cards: [
            code
        ]
    }, {
        signal: controller?.signal
    });
const deleteSalesCheckoutGiftCards = async ({ client , controller , code  } = {})=>await client.delete(`V1/sales/checkout/gift-cards/${code}`, {
        signal: controller?.signal
    });
deleteSalesCheckoutGiftCards.key = 'deleteSalesCheckoutGiftCards';
const postSalesCheckoutGiftOptions = async ({ client , controller , sender , recipient , message , wrapId , livStickVideo  } = {})=>await client.post(`V1/sales/checkout/gift-options`, {
        sender,
        recipient,
        message,
        wrapping_id: parseInt(wrapId) > 0 ? parseInt(wrapId) : 0,
        wrapping_allow_gift_receipt: false,
        wrapping_add_printed_card: false,
        ...livStickVideo ? {
            livstick_video: livStickVideo
        } : {}
    }, {
        signal: controller?.signal
    });
postSalesCheckoutGiftOptions.key = 'postSalesCheckoutGiftOptions';
const getSalesCheckoutGiftOptions = async ({ client , controller  } = {})=>await client.get(`V1/sales/checkout/gift-options`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesCheckoutGiftOptionsResponse)
        ]
    });
getSalesCheckoutGiftOptions.key = 'getSalesCheckoutGiftOptions';
const getSalesCheckoutMeTotals = async ({ client , controller  } = {})=>await client.get(`V1/sales/checkout/me/totals`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesCheckoutMeTotalsResponse)
        ]
    });
getSalesCheckoutMeTotals.key = 'getSalesCheckoutMeTotals';
const getSalesCheckoutPaymentMethods = async ({ client , controller  } = {})=>await client.get(`V1/sales/checkout/payment-methods`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesCheckoutPaymentMethodsResponse)
        ]
    });
getSalesCheckoutPaymentMethods.key = 'getSalesCheckoutPaymentMethods';
const postSalesCheckoutPaymentMethods = async ({ client , controller , code  } = {})=>await client.post(`V1/sales/checkout/payment-methods`, {
        method: code
    }, {
        signal: controller?.signal
    });
postSalesCheckoutPaymentMethods.key = 'postSalesCheckoutPaymentMethods';
const getSalesCheckoutShippingMethods = async ({ client , controller  } = {})=>await client.get(`V1/sales/checkout/shipping-methods`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesCheckoutShippingMethodsResponse)
        ]
    });
getSalesCheckoutShippingMethods.key = 'getSalesCheckoutShippingMethods';
const postSalesCheckoutShippingMethods = async ({ client , controller , countryCode , postcode  } = {})=>await client.post(`V1/sales/checkout/shipping-methods`, {
        country_id: countryCode,
        postcode: postcode ?? ''
    }, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformPostSalesCheckoutShippingMethodsResponse)
        ]
    });
postSalesCheckoutShippingMethods.key = 'postSalesCheckoutShippingMethods';
const getSalesGiftWrap = async ({ client , controller  } = {})=>await client.get(`V1/sales/gift-wrap`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesGiftWrapResponse)
        ]
    });
getSalesGiftWrap.key = 'getSalesGiftWrap';
const postSalesCheckoutShipping = async ({ client , controller , billingAddress , shippingAddress , shippingCarrierCode , shippingMethodCode , externalPickUpServicesIds  } = {})=>await client.post(`V1/sales/checkout/shipping`, {
        billingAddress,
        shippingAddress,
        shippingCarrierCode,
        shippingMethodCode,
        externalPickUpServicesIds
    }, {
        signal: controller?.signal,
        transformRequest: [
            transformSalesCheckoutShippingRequest,
            ...(client || defaultClient).defaults.transformRequest
        ],
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesCheckoutShippingResponse)
        ]
    });
postSalesCheckoutShipping.key = 'postSalesCheckoutShipping';
const postSalesCheckoutPlaceOrder = async ({ client , controller , paymentMethod , paymentInformations , fiscalInformation , recaptchaToken , recaptchaAction  })=>{
    const params = new URLSearchParams({
        ...recaptchaToken ? {
            recaptcha_token: recaptchaToken
        } : {},
        ...recaptchaAction ? {
            recaptcha_action: recaptchaAction
        } : {}
    });
    return await client.post(`V1/sales/checkout/place-order${params.toString() ? `?` + params.toString() : ''}`, {
        paymentMethod,
        paymentInformations,
        fiscalInformation
    }, {
        signal: controller?.signal,
        transformRequest: [
            transformSalesCheckoutPlaceOrderRequest,
            ...(client || defaultClient).defaults.transformRequest
        ],
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesCheckoutPlaceOrderResponse)
        ]
    });
};
postSalesCheckoutPlaceOrder.key = 'postSalesCheckoutPlaceOrder';
const getSalesPaymentCheckoutDetails = async ({ client , controller , code , checkoutSessionId  })=>await client.get(`/V1/sales/payment/checkout/details/${code}/${checkoutSessionId}`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesPaymentCheckoutDetailsResponse)
        ]
    });
getSalesPaymentCheckoutDetails.key = 'getSalesPaymentCheckoutDetails';
const postSalesPaymentInit = async ({ client , controller , code , returnUrl  })=>await client.post(`/V1/sales/payment/init/${code}`, {
        additionalInformation: {
            return_url: returnUrl
        }
    }, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesPaymentInitResponse)
        ]
    });
postSalesPaymentInit.key = 'postSalesPaymentInit';
const postSalesCheckoutFiloBluVatValidation = async ({ client , controller , vatNumber , countryCode  })=>await client.post(`V1/sales/checkout/filoblu-vat-validation/`, {
        vatNumber,
        countryCode
    }, {
        signal: controller?.signal,
        transformRequest: [
            transformSalesCheckoutVatValidationRequest,
            ...(client || defaultClient).defaults.transformRequest
        ],
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesCheckoutVatValidationResponse)
        ]
    });
postSalesCheckoutFiloBluVatValidation.key = 'postSalesCheckoutFiloBluVatValidation';

export { deleteSalesCheckoutCoupon, deleteSalesCheckoutGiftCards, getSalesCheckoutCoupon, getSalesCheckoutGiftOptions, getSalesCheckoutMeTotals, getSalesCheckoutPaymentMethods, getSalesCheckoutShippingMethods, getSalesGiftWrap, getSalesPaymentCheckoutDetails, postSalesCheckoutBillingAddress, postSalesCheckoutCoupon, postSalesCheckoutFiloBluVatValidation, postSalesCheckoutGiftCards, postSalesCheckoutGiftOptions, postSalesCheckoutPaymentMethods, postSalesCheckoutPlaceOrder, postSalesCheckoutShipping, postSalesCheckoutShippingMethods, postSalesPaymentInit };
